const THEME_KEY = 'theme'
type ThemeMode = 'light' | 'dark' | 'auto'

function systemPrefersDark() {
  try { return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches } catch { return false }
}

export function initTheme() {
  const saved = (localStorage.getItem(THEME_KEY) as ThemeMode | null) || 'auto'
  applyTheme(saved)
  // keep in sync if auto
  try {
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = () => { if ((localStorage.getItem(THEME_KEY) as ThemeMode) === 'auto') applyTheme('auto') }
    mq.addEventListener?.('change', onChange)
  } catch {}
}

export function toggleTheme() {
  const current = (localStorage.getItem(THEME_KEY) as ThemeMode) || 'auto'
  const next: ThemeMode = current === 'light' ? 'dark' : current === 'dark' ? 'auto' : 'light'
  applyTheme(next)
}

export function applyTheme(mode: ThemeMode) {
  const effectiveDark = mode === 'auto' ? systemPrefersDark() : (mode === 'dark')
  if (effectiveDark) {
    document.documentElement.classList.add('dark')
    document.body?.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
    document.body?.classList.remove('dark')
  }
  localStorage.setItem(THEME_KEY, mode)
}
